import React, { useState, useEffect } from 'react';
import { API_URL, fmtFecha, descargarBase64 } from '../constants';
import { SeccionLabel, fileToBase64, toYMDLocal } from './shared';

// ════════════════════════════════════════════════════════════════════════════
// VISTA CAPACITACIONES (sección principal)
// ════════════════════════════════════════════════════════════════════════════
const EXPOSITORES = ['Rosario Navarro', 'Roberto Aldape', 'Miriam Villarreal'];

export function VistaCapacitaciones() {
  const [caps, setCaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalCrear, setModalCrear] = useState(false);
  const [detalleId, setDetalleId] = useState(null);

  const cargar = () => {
    setLoading(true);
    fetch(API_URL + '?path=api/capacitaciones/listar')
      .then(r => r.json())
      .then(d => { if (d.success) setCaps(d.capacitaciones || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, []);

  return (
    <div style={{ padding: '24px', maxWidth: '860px' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <div>
          <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#1d3d6b', margin: 0 }}><i className="ti ti-school"></i> Capacitaciones</h1>
          <p style={{ fontSize: '13px', color: '#6b7280', margin: '4px 0 0' }}>Cursos permanentes y sus registros históricos</p>
        </div>
        <button className="btn-primary" onClick={() => setModalCrear(true)} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="ti ti-plus"></i> Crear Capacitación
        </button>
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ padding: '60px', textAlign: 'center', color: '#9ca3af' }}>Cargando...</div>
      ) : caps.length === 0 ? (
        <div style={{ padding: '60px', textAlign: 'center', color: '#9ca3af' }}>
          <i className="ti ti-school" style={{ fontSize: '48px', display: 'block', marginBottom: '12px' }}></i>
          <p style={{ fontWeight: 600, marginBottom: '4px' }}>Sin capacitaciones registradas</p>
          <p style={{ fontSize: '13px' }}>Crea el primer curso con el botón de arriba</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {caps.map(cap => (
            <div key={cap.id} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '18px 20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ width: '48px', height: '48px', background: '#ede9fe', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="ti ti-book-2" style={{ fontSize: '22px', color: '#7c3aed' }}></i>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <span style={{ fontWeight: 700, fontSize: '15px', color: '#1d3d6b' }}>{cap.nombre}</span>
                  <span style={{ fontSize: '11px', background: '#f3f4f6', color: '#6b7280', padding: '1px 8px', borderRadius: '12px', fontFamily: 'monospace' }}>{cap.id}</span>
                  {cap.estatus === 'Activa' && (
                    <span style={{ fontSize: '11px', background: '#dcfce7', color: '#166534', padding: '1px 8px', borderRadius: '12px', fontWeight: 600 }}>Activa</span>
                  )}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  {cap.tema && <span><i className="ti ti-tag"></i> {cap.tema}</span>}
                  {cap.expositor && <span><i className="ti ti-user"></i> {cap.expositor}</span>}
                  <span><i className="ti ti-users"></i> {cap.participantes_count} participante{cap.participantes_count !== 1 ? 's' : ''} acumulados</span>
                  <span><i className="ti ti-file-text"></i> {cap.registros_count} registro{cap.registros_count !== 1 ? 's' : ''}</span>
                </div>
              </div>
              <button className="btn-secondary" onClick={() => setDetalleId(cap.id)} style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                Ver Detalles
              </button>
            </div>
          ))}
        </div>
      )}

      {modalCrear && (
        <ModalCrearCapacitacion onClose={() => setModalCrear(false)} onCreado={() => { setModalCrear(false); cargar(); }} />
      )}
      {detalleId && (
        <ModalDetallesCapacitacion id={detalleId} onClose={() => { setDetalleId(null); cargar(); }} />
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL CREAR CAPACITACIÓN
// ════════════════════════════════════════════════════════════════════════════
export function ModalCrearCapacitacion({ onClose, onCreado }) {
  const [form, setForm] = useState({ nombre: '', tema: '', expositor: '', lugar: '', duracion: '' });
  const [guardando, setGuardando] = useState(false);
  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleGuardar = async () => {
    if (!form.nombre.trim()) return alert('El nombre es requerido');
    setGuardando(true);
    try {
      const res = await fetch(API_URL + '?path=api/capacitaciones/crear', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      const result = await res.json();
      if (result.success) {
        alert('✅ Capacitación creada con ID: ' + result.id);
        onCreado();
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-plus"></i> Crear Capacitación</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div className="form-group">
              <label>Nombre del curso <span style={{ color: '#ef4444' }}>*</span></label>
              <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Ej. Inducción General Nuevo Ingreso" autoFocus />
            </div>
            <div className="form-group">
              <label>Tema</label>
              <input name="tema" value={form.tema} onChange={handleChange} placeholder="Ej. Inducción, Seguridad, RRHH..." />
            </div>
            <div className="form-group">
              <label>Expositor</label>
              <select name="expositor" value={form.expositor} onChange={handleChange}>
                <option value="">— Seleccionar —</option>
                {EXPOSITORES.map(e => <option key={e} value={e}>{e}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Lugar</label>
              <input name="lugar" value={form.lugar} onChange={handleChange} placeholder="Ej. Oficina RH, Sala de juntas..." />
            </div>
            <div className="form-group">
              <label>Duración</label>
              <input name="duracion" value={form.duracion} onChange={handleChange} placeholder="Ej. 1 hora, 2 horas..." />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn-primary" onClick={handleGuardar} disabled={guardando}>
            {guardando ? 'Guardando...' : <><i className="ti ti-device-floppy"></i> Guardar</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL DETALLES CAPACITACIÓN
// ════════════════════════════════════════════════════════════════════════════
export function ModalDetallesCapacitacion({ id, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('registros');

  useEffect(() => {
    fetch(API_URL + `?path=api/capacitaciones/detalle&id=${encodeURIComponent(id)}`)
      .then(r => r.json())
      .then(d => { if (d.success) setData(d.capacitacion); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  const cap = data || {};
  const registros = cap.registros || [];
  const participantes = cap.participantes || [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '640px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-book"></i> {cap.nombre || id}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af' }}>Cargando...</div>
          ) : (
            <>
              {/* Info del curso */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', fontSize: '13px', padding: '14px 16px', background: '#f8fafc', borderRadius: '10px', marginBottom: '18px' }}>
                <div><span style={{ color: '#9ca3af' }}>ID: </span><strong style={{ fontFamily: 'monospace' }}>{cap.id}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>Tema: </span><strong>{cap.tema || '—'}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>Expositor: </span><strong>{cap.expositor || '—'}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>Lugar: </span><strong>{cap.lugar || '—'}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>Duración: </span><strong>{cap.duracion || '—'}</strong></div>
                <div><span style={{ color: '#9ca3af' }}>Participantes: </span><strong>{cap.participantes_count || 0} acumulados</strong></div>
              </div>

              {/* Tabs */}
              <div style={{ display: 'flex', gap: '4px', marginBottom: '16px', borderBottom: '1px solid #e5e7eb', paddingBottom: '0' }}>
                {[['registros', 'ti-file-description', `Registros (${registros.length})`], ['participantes', 'ti-users', `Participantes (${participantes.length})`]].map(([key, icon, label]) => (
                  <button key={key} onClick={() => setTab(key)} style={{
                    padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                    display: 'flex', alignItems: 'center', gap: '6px',
                    color: tab === key ? '#1d3d6b' : '#9ca3af',
                    borderBottom: tab === key ? '2px solid #1d3d6b' : '2px solid transparent',
                    marginBottom: '-1px'
                  }}><i className={`ti ${icon}`}></i>{label}</button>
                ))}
              </div>

              {tab === 'registros' && (
                registros.length === 0 ? (
                  <div style={{ padding: '30px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>
                    Sin registros de asistencia aún
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[...registros].reverse().map((reg, i) => (
                      <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: '14px', color: '#1d3d6b' }}>{reg.fecha}</div>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>{reg.participantes} participante{reg.participantes !== 1 ? 's' : ''}</div>
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <a href={reg.url} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '5px 10px', background: '#1d3d6b', color: 'white', borderRadius: '6px', textDecoration: 'none', fontSize: '11px', fontWeight: 500 }}>
                            <i className="ti ti-eye"></i> Ver
                          </a>
                          <a href={reg.url} download target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '5px 10px', background: '#059669', color: 'white', borderRadius: '6px', textDecoration: 'none', fontSize: '11px', fontWeight: 500 }}>
                            <i className="ti ti-download"></i> Descargar
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              )}

              {tab === 'participantes' && (
                participantes.length === 0 ? (
                  <div style={{ padding: '30px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>
                    Sin participantes registrados
                  </div>
                ) : (
                  <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                      <thead>
                        <tr style={{ background: '#f3f4f6' }}>
                          <th style={{ padding: '8px 10px', textAlign: 'left' }}># Emp</th>
                          <th style={{ padding: '8px 10px', textAlign: 'left' }}>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        {participantes.map((p, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <td style={{ padding: '8px 10px', fontFamily: 'monospace', color: '#6b7280' }}>#{p.id}</td>
                            <td style={{ padding: '8px 10px', fontWeight: 500 }}>{p.nombre}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// TAB CAPACITACIONES (dentro de ModalExpediente)
// ════════════════════════════════════════════════════════════════════════════
export function TabCapacitaciones({ empleadoId }) {
  const [caps, setCaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandido, setExpandido] = useState(null);

  useEffect(() => {
    fetch(API_URL + `?path=api/empleado/capacitaciones&id=${empleadoId}`)
      .then(r => r.json())
      .then(d => { if (d.success) setCaps(d.capacitaciones || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [empleadoId]);

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Cargando capacitaciones...</div>
  );

  return (
    <div className="expediente-cap-card" data-expediente-capacitaciones>
      <div className="expediente-cap-head">
        <div className="expediente-cap-head-texto">
          <div className="expediente-section-title"><i className="ti ti-book"></i> Capacitaciones tomadas</div>
          <p className="expediente-cap-desc">Historial de formación asociado al empleado.</p>
        </div>
        {caps.length > 0 && (
          <span className="expediente-cap-total">{caps.length} {caps.length === 1 ? 'curso' : 'cursos'}</span>
        )}
      </div>

      {caps.length === 0 ? (
        <div className="expediente-cap-vacio" data-cap-vacio>
          <i className="ti ti-book" aria-hidden="true"></i>
          <div className="expediente-cap-vacio-titulo">Sin capacitaciones registradas</div>
          <div className="expediente-cap-vacio-texto">No hay capacitaciones asociadas a este empleado.</div>
        </div>
      ) : (
        <div className="expediente-cap-lista">
          {caps.map(cap => {
            const registros = cap.registros || [];
            const abierto = expandido === cap.id;
            return (
              <div key={cap.id} className={`expediente-cap-item${abierto ? ' expediente-cap-abierto' : ''}`}>
                <button
                  type="button"
                  className="expediente-cap-fila"
                  aria-expanded={abierto}
                  onClick={() => setExpandido(abierto ? null : cap.id)}
                >
                  <span className="expediente-cap-icono"><i className="ti ti-school"></i></span>
                  <span className="expediente-cap-info">
                    <span className="expediente-cap-nombre">{cap.nombre}</span>
                    <span className="expediente-cap-meta">
                      {cap.tema && `${cap.tema}`}{cap.expositor && ` · ${cap.expositor}`}{cap.duracion && ` · ${cap.duracion}`}
                      {registros.length > 0 && ` · ${registros.length} registro${registros.length !== 1 ? 's' : ''}`}
                    </span>
                  </span>
                  <i className={`ti ${abierto ? 'ti-chevron-up' : 'ti-chevron-down'} expediente-cap-chevron`}></i>
                </button>

                {abierto && (
                  <div className="expediente-cap-detalle">
                    {/* Info del curso */}
                    {(cap.expositor || cap.lugar || cap.duracion) && (
                      <div className="expediente-cap-resumen">
                        {cap.expositor && <div className="expediente-cap-dato"><span className="expediente-cap-etiqueta">Expositor</span><strong>{cap.expositor}</strong></div>}
                        {cap.lugar && <div className="expediente-cap-dato"><span className="expediente-cap-etiqueta">Lugar</span><strong>{cap.lugar}</strong></div>}
                        {cap.duracion && <div className="expediente-cap-dato"><span className="expediente-cap-etiqueta">Duración</span><strong>{cap.duracion}</strong></div>}
                      </div>
                    )}

                    {/* Registros históricos */}
                    {registros.length === 0 ? (
                      <div className="expediente-cap-pendiente">
                        <i className="ti ti-clock"></i> Registro de asistencia pendiente de cargar
                      </div>
                    ) : (
                      <div className="expediente-cap-registros">
                        {[...registros].reverse().map((reg, i) => (
                          <div key={i} className="expediente-cap-registro">
                            <span className="expediente-cap-reg-icono"><i className="ti ti-calendar"></i></span>
                            <div className="expediente-cap-reg-info">
                              <strong>{reg.fecha}</strong>
                              <span>{reg.participantes} participante{reg.participantes !== 1 ? 's' : ''}</span>
                            </div>
                            <div className="expediente-cap-reg-acciones">
                              <a href={reg.url} target="_blank" rel="noreferrer" className="expediente-cap-btn">
                                <i className="ti ti-eye"></i> Ver PDF
                              </a>
                              <a href={reg.url} download target="_blank" rel="noreferrer" className="expediente-cap-btn expediente-cap-btn-icono" aria-label="Descargar registro" title="Descargar">
                                <i className="ti ti-download"></i>
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL ALTAS Y BAJAS PENDIENTES
// ════════════════════════════════════════════════════════════════════════════
export function ModalAltasBajas({ onClose }) {
  const [altas, setAltas] = useState([]);
  const [bajas, setBajas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selAltas, setSelAltas] = useState({});
  const [selBajas, setSelBajas] = useState({});
  const [marcarEnviado, setMarcarEnviado] = useState(false);
  const [generando, setGenerando] = useState(false);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    fetch(API_URL + '?path=api/pendientes/altas-bajas')
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setAltas(d.altas || []);
          setBajas(d.bajas || []);
          const sa = {}, sb = {};
          (d.altas || []).forEach(a => sa[a.id] = true);
          (d.bajas || []).forEach(b => sb[b.id] = true);
          setSelAltas(sa);
          setSelBajas(sb);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const altasSelec = altas.filter(a => selAltas[a.id]);
  const bajasSelec = bajas.filter(b => selBajas[b.id]);
  const haySeleccion = altasSelec.length > 0 || bajasSelec.length > 0;

  const handleGenExcel = async () => {
    if (!haySeleccion) return;
    setGenerando(true);
    try {
      const payload = {
        idsBajas: bajasSelec.map(b => b.id),
        idsAltas: altasSelec.map(a => a.id)
      };
      const res = await fetch(API_URL + `?path=api/bajas/generar-hoja-imss&payload=${encodeURIComponent(JSON.stringify(payload))}`);
      const result = await res.json();
      if (result.success) {
        descargarBase64(result.base64, result.filename);
        alert(`✅ Hoja IMSS generada — ${result.total_altas} alta(s) y ${result.total_bajas} baja(s) marcadas como enviadas.`);
        if (marcarEnviado) await handleMarcarEnviado();
        onClose();
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGenerando(false);
    }
  };

  const handleCopiarEmail = async () => {
    if (!haySeleccion) return;
    try {
      const payload = encodeURIComponent(JSON.stringify({ altas: altasSelec, bajas: bajasSelec }));
      const res = await fetch(API_URL + `?path=api/generar/email-altas-bajas&payload=${payload}`);
      const result = await res.json();
      if (result.success) {
        await navigator.clipboard.writeText(result.texto);
        setCopiado(true);
        setTimeout(() => setCopiado(false), 3000);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleMarcarEnviado = async () => {
    const ids = [...altasSelec.map(a => a.id), ...bajasSelec.map(b => b.id)];
    if (!ids.length) return;
    const payload = encodeURIComponent(JSON.stringify({ ids }));
    await fetch(API_URL + `?path=api/pendientes/marcar-enviado&payload=${payload}`);
    // Recargar lista
    const res = await fetch(API_URL + '?path=api/pendientes/altas-bajas');
    const d = await res.json();
    if (d.success) { setAltas(d.altas || []); setBajas(d.bajas || []); }
  };

  const toggleAlta = (id) => setSelAltas(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleBaja = (id) => setSelBajas(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '680px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-file-invoice"></i> Altas y Bajas Pendientes</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>Cargando...</div>
          ) : (
            <>
              {/* ALTAS */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <SeccionLabel icon="ti-user-plus">Altas Pendientes</SeccionLabel>
                  <span style={{ fontSize: '12px', background: '#dcfce7', color: '#166534', padding: '2px 10px', borderRadius: '20px', fontWeight: 600 }}>
                    {altas.length} {altas.length === 1 ? 'alta' : 'altas'}
                  </span>
                </div>
                {altas.length === 0 ? (
                  <div style={{ padding: '16px', background: '#f9fafb', borderRadius: '8px', color: '#9ca3af', fontSize: '13px', textAlign: 'center' }}>
                    Sin altas pendientes
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#f3faf3' }}>
                        <th style={{ padding: '8px', textAlign: 'center', width: '40px' }}></th>
                        <th style={{ padding: '8px', textAlign: 'left' }}># Emp</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Nombre</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Fecha Ingreso</th>
                      </tr>
                    </thead>
                    <tbody>
                      {altas.map(a => (
                        <tr key={a.id} style={{ borderBottom: '1px solid #e5e7eb', background: selAltas[a.id] ? '#f0fdf4' : 'white' }}>
                          <td style={{ padding: '8px', textAlign: 'center' }}>
                            <input type="checkbox" checked={!!selAltas[a.id]} onChange={() => toggleAlta(a.id)} />
                          </td>
                          <td style={{ padding: '8px', fontFamily: 'monospace' }}>#{a.id}</td>
                          <td style={{ padding: '8px', fontWeight: 500 }}>{a.nombre}</td>
                          <td style={{ padding: '8px', color: '#6b7280' }}>{fmtFecha(a.fecha_ingreso)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* BAJAS */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <SeccionLabel icon="ti-user-minus">Bajas Pendientes</SeccionLabel>
                  <span style={{ fontSize: '12px', background: '#fee2e2', color: '#991b1b', padding: '2px 10px', borderRadius: '20px', fontWeight: 600 }}>
                    {bajas.length} {bajas.length === 1 ? 'baja' : 'bajas'}
                  </span>
                </div>
                {bajas.length === 0 ? (
                  <div style={{ padding: '16px', background: '#f9fafb', borderRadius: '8px', color: '#9ca3af', fontSize: '13px', textAlign: 'center' }}>
                    Sin bajas pendientes
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ background: '#fef2f2' }}>
                        <th style={{ padding: '8px', textAlign: 'center', width: '40px' }}></th>
                        <th style={{ padding: '8px', textAlign: 'left' }}># Emp</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Nombre</th>
                        <th style={{ padding: '8px', textAlign: 'left' }}>Fecha Baja</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bajas.map(b => (
                        <tr key={b.id} style={{ borderBottom: '1px solid #e5e7eb', background: selBajas[b.id] ? '#fef2f2' : 'white' }}>
                          <td style={{ padding: '8px', textAlign: 'center' }}>
                            <input type="checkbox" checked={!!selBajas[b.id]} onChange={() => toggleBaja(b.id)} />
                          </td>
                          <td style={{ padding: '8px', fontFamily: 'monospace' }}>#{b.id}</td>
                          <td style={{ padding: '8px', fontWeight: 500 }}>{b.nombre}</td>
                          <td style={{ padding: '8px', color: '#6b7280' }}>{fmtFecha(b.fecha_baja)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Opciones */}
              <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '14px 16px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', marginBottom: '12px' }}>
                  <input type="checkbox" checked={marcarEnviado} onChange={e => setMarcarEnviado(e.target.checked)} />
                  <span>Marcar seleccionados como <strong>enviados al contador</strong> al generar</span>
                </label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button
                    className="btn-primary"
                    onClick={handleGenExcel}
                    disabled={!haySeleccion || generando}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <i className="ti ti-file-spreadsheet"></i>
                    {generando ? 'Generando...' : 'Generar Excel'}
                  </button>
                  <button
                    className="btn-secondary"
                    onClick={handleCopiarEmail}
                    disabled={!haySeleccion}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <i className="ti ti-clipboard"></i>
                    {copiado ? '✅ Copiado' : 'Copiar Email'}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL REGISTRO DEL DÍA
// ════════════════════════════════════════════════════════════════════════════
export function ModalRegistroDia({ onClose }) {
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [capSelecId, setCapSelecId] = useState('');
  const [lugar, setLugar] = useState('');
  const [duracion, setDuracion] = useState('');
  const [expositor, setExpositor] = useState('');
  const [empleados, setEmpleados] = useState([]);
  const [selEmp, setSelEmp] = useState({});
  const [loadingEmp, setLoadingEmp] = useState(true);
  const [generandoPdf, setGenerandoPdf] = useState(false);

  useEffect(() => {
    Promise.all([
      fetch(API_URL + '?path=api/capacitaciones/listar').then(r => r.json()),
      fetch(API_URL + '?path=api/empleados/hoy').then(r => r.json())
    ]).then(([dCap, dEmp]) => {
      if (dCap.success) setCapacitaciones(dCap.capacitaciones || []);
      if (dEmp.success) {
        const emps = dEmp.empleados || [];
        setEmpleados(emps);
        const sel = {};
        emps.forEach(e => { sel[e.id] = true; });
        setSelEmp(sel);
      }
    }).catch(() => {}).finally(() => setLoadingEmp(false));
  }, []);

  // Pre-llenar campos cuando se selecciona capacitación
  useEffect(() => {
    if (!capSelecId) return;
    const cap = capacitaciones.find(c => c.id === capSelecId);
    if (cap) {
      if (cap.expositor) setExpositor(cap.expositor);
      if (cap.lugar) setLugar(cap.lugar);
      if (cap.duracion) setDuracion(cap.duracion);
    }
  }, [capSelecId]);

  const empSeleccionados = empleados.filter(e => selEmp[e.id]);

  const generarRegistroPdf = async () => {
    if (!capSelecId) return alert('Selecciona una capacitación');
    if (empSeleccionados.length === 0) return alert('Selecciona al menos un empleado');
    const cap = capacitaciones.find(c => c.id === capSelecId) || {};
    setGenerandoPdf(true);
    try {
      const hoy = toYMDLocal(new Date());
      const body = JSON.stringify({
        fecha: hoy,
        tema: cap.nombre || cap.tema || '',
        lugar,
        duracion,
        expositor,
        empleados: empSeleccionados
      });
      const res = await fetch(API_URL + '?path=api/registro/generar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
      const result = await res.json();
      if (result.success) {
        window.open(result.pdf_url, '_blank');
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGenerandoPdf(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '580px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-calendar-event"></i> Registro del Día</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {/* Capacitación */}
          <div className="form-group" style={{ marginBottom: '16px' }}>
            <label>Capacitación <span style={{ color: '#ef4444' }}>*</span></label>
            <select value={capSelecId} onChange={e => setCapSelecId(e.target.value)}>
              <option value="">— Seleccionar capacitación —</option>
              {capacitaciones.map(c => (
                <option key={c.id} value={c.id}>{c.nombre} ({c.id})</option>
              ))}
            </select>
            {capacitaciones.length === 0 && (
              <p style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>No hay capacitaciones creadas. Ve a la sección Capacitaciones para crear una.</p>
            )}
          </div>

          <div className="form-grid" style={{ marginBottom: '16px' }}>
            <div className="form-group">
              <label>Expositor</label>
              <select value={expositor} onChange={e => setExpositor(e.target.value)}>
                <option value="">— Seleccionar —</option>
                {EXPOSITORES.map(ex => <option key={ex} value={ex}>{ex}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Lugar</label>
              <input type="text" value={lugar} onChange={e => setLugar(e.target.value)} placeholder="Ej. Oficina RH" />
            </div>
            <div className="form-group">
              <label>Duración</label>
              <input type="text" value={duracion} onChange={e => setDuracion(e.target.value)} placeholder="Ej. 1 hora" />
            </div>
          </div>

          {/* Empleados */}
          <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Empleados con ingreso hoy</span>
            <span style={{ fontWeight: 400, textTransform: 'none', fontSize: '12px', color: '#1d3d6b' }}>{empSeleccionados.length} seleccionados</span>
          </div>

          {loadingEmp ? (
            <div style={{ color: '#9ca3af', fontSize: '13px', padding: '16px 0' }}>Cargando empleados...</div>
          ) : empleados.length === 0 ? (
            <div style={{ color: '#9ca3af', fontSize: '13px', padding: '20px 0', textAlign: 'center', background: '#f9fafb', borderRadius: '8px' }}>Sin ingresos hoy</div>
          ) : (
            <div style={{ maxHeight: '220px', overflowY: 'auto', border: '1px solid #e8ecf0', borderRadius: '8px' }}>
              <table className="tabla">
                <thead>
                  <tr>
                    <th style={{ width: '40px' }}>
                      <input type="checkbox"
                        checked={empleados.every(e => selEmp[e.id])}
                        onChange={ev => { const s = {}; empleados.forEach(e => { s[e.id] = ev.target.checked; }); setSelEmp(s); }}
                      />
                    </th>
                    <th>ID</th><th>Nombre</th><th>Puesto</th>
                  </tr>
                </thead>
                <tbody>
                  {empleados.map(e => (
                    <tr key={e.id} style={{ background: selEmp[e.id] ? '#f0f9ff' : 'white' }}>
                      <td style={{ textAlign: 'center' }}>
                        <input type="checkbox" checked={!!selEmp[e.id]} onChange={() => setSelEmp(prev => ({ ...prev, [e.id]: !prev[e.id] }))} />
                      </td>
                      <td style={{ fontFamily: 'monospace', color: '#6b7280' }}>#{e.id}</td>
                      <td style={{ fontWeight: 500 }}>{e.nombre}</td>
                      <td style={{ color: '#6b7280' }}>{e.puesto}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
          <button className="btn-primary" onClick={generarRegistroPdf} disabled={!capSelecId || empSeleccionados.length === 0 || generandoPdf}>
            <i className="ti ti-file-type-pdf"></i> {generandoPdf ? 'Generando PDF...' : 'Generar Registro FOR-RHU-02'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL SUBIR ESCANEO DE REGISTRO
// ════════════════════════════════════════════════════════════════════════════
export function ModalSubirEscaneo({ empleado, onClose }) {
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [capSelecId, setCapSelecId] = useState('');
  const [empleados, setEmpleados] = useState([]);
  const [selEmp, setSelEmp] = useState({});
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [loadingInit, setLoadingInit] = useState(true);
  const hoy = toYMDLocal(new Date());

  useEffect(() => {
    Promise.all([
      fetch(API_URL + '?path=api/capacitaciones/listar').then(r => r.json()),
      fetch(API_URL + '?path=api/empleados/hoy').then(r => r.json())
    ]).then(([dCap, dEmp]) => {
      if (dCap.success) setCapacitaciones(dCap.capacitaciones || []);
      if (dEmp.success) {
        const emps = dEmp.empleados || [];
        setEmpleados(emps);
        const sel = {};
        emps.forEach(e => { sel[e.id] = true; });
        setSelEmp(sel);
      }
    }).catch(() => {}).finally(() => setLoadingInit(false));
  }, []);

  const empSeleccionados = empleados.filter(e => selEmp[e.id]);

  const handleSubir = async () => {
    if (!archivo) return alert('Selecciona un archivo');
    if (!capSelecId) return alert('Selecciona una capacitación');
    if (empSeleccionados.length === 0) return alert('Selecciona al menos un empleado');
    setSubiendo(true);
    try {
      const base64 = await fileToBase64(archivo);
      const body = JSON.stringify({
        id_capacitacion: capSelecId,
        base64: base64.split(',')[1],
        nombre_archivo: archivo.name,
        fecha: hoy,
        empleados: empSeleccionados.map(e => e.id)
      });
      const res = await fetch(API_URL + '?path=api/capacitaciones/subir-registro', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
      const result = await res.json();
      if (result.success) {
        alert(`✅ Escaneo vinculado a ${capSelecId}. ${result.empleados_vinculados} empleado(s) registrados.`);
        onClose();
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: '520px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-upload"></i> Subir Registro Escaneado</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {loadingInit ? (
            <div style={{ padding: '30px', textAlign: 'center', color: '#9ca3af' }}>Cargando...</div>
          ) : (
            <>
              <div className="form-group" style={{ marginBottom: '14px' }}>
                <label>Capacitación <span style={{ color: '#ef4444' }}>*</span></label>
                <select value={capSelecId} onChange={e => setCapSelecId(e.target.value)}>
                  <option value="">— Seleccionar —</option>
                  {capacitaciones.map(c => (
                    <option key={c.id} value={c.id}>{c.nombre} ({c.id})</option>
                  ))}
                </select>
                {capacitaciones.length === 0 && (
                  <p style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>No hay capacitaciones. Créalas en la sección Capacitaciones.</p>
                )}
              </div>

              <div className="form-group" style={{ marginBottom: '14px' }}>
                <label>Fecha del registro</label>
                <input type="text" value={hoy} readOnly style={{ background: '#f3f4f6', cursor: 'not-allowed' }} />
              </div>

              <div className="form-group" style={{ marginBottom: '14px' }}>
                <label>Archivo (PDF, JPG o PNG) <span style={{ color: '#ef4444' }}>*</span></label>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setArchivo(e.target.files[0] || null)} />
                {archivo && (
                  <div style={{ marginTop: '6px', fontSize: '12px', color: '#1d3d6b' }}>
                    📎 {archivo.name} ({(archivo.size / 1024).toFixed(1)} KB)
                  </div>
                )}
              </div>

              {/* Empleados */}
              {empleados.length > 0 && (
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
                    <span>Empleados participantes</span>
                    <span style={{ fontWeight: 400, textTransform: 'none', fontSize: '12px', color: '#1d3d6b' }}>{empSeleccionados.length} seleccionados</span>
                  </div>
                  <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e8ecf0', borderRadius: '8px' }}>
                    <table className="tabla">
                      <thead>
                        <tr>
                          <th style={{ width: '36px' }}>
                            <input type="checkbox"
                              checked={empleados.every(e => selEmp[e.id])}
                              onChange={ev => { const s = {}; empleados.forEach(e => { s[e.id] = ev.target.checked; }); setSelEmp(s); }}
                            />
                          </th>
                          <th>ID</th><th>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empleados.map(e => (
                          <tr key={e.id} style={{ background: selEmp[e.id] ? '#f0f9ff' : 'white' }}>
                            <td style={{ textAlign: 'center' }}>
                              <input type="checkbox" checked={!!selEmp[e.id]} onChange={() => setSelEmp(prev => ({ ...prev, [e.id]: !prev[e.id] }))} />
                            </td>
                            <td style={{ fontFamily: 'monospace', color: '#6b7280', fontSize: '12px' }}>#{e.id}</td>
                            <td style={{ fontWeight: 500 }}>{e.nombre}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn-primary" onClick={handleSubir} disabled={!archivo || !capSelecId || subiendo}>
            {subiendo ? 'Subiendo...' : '⬆️ Guardar y Distribuir'}
          </button>
        </div>
      </div>
    </div>
  );
}
